// extracted by mini-css-extract-plugin
export default {"capacityDetails":"_6eiBKDSCzzRQICB1quqrKO"};